// @ts-nocheck
import { PreferencesInvoicesBoot } from './PreferencesInvoiceFormBoot';
import PreferencesInvoiceFormPage from './PreferencesInvoiceFormPage';

/**
 * items preferences.
 */
export default function PreferencesInvoices() {
  return (
    <PreferencesInvoicesBoot>
      <PreferencesInvoiceFormPage />
    </PreferencesInvoicesBoot>
  );
}
